  <ngx-loading-bar height="3px" [color]="colors.BLUE" [includeSpinner]="false"></ngx-loading-bar>
<slm-notification class="notification"></slm-notification>
<router-outlet></router-outlet>
